<template>
<div class="chapter">
<div class="inner_page">
<p class="P_TOC_Heading" id="tableofcontents">Table of Contents</p>
<p class="P_TOC_Entry_1"><a href="#/section0002#auto_bookmark_toc_2">Blurb</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0003#a__Hlk132640019">Acknowledgments</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0004#auto_bookmark_toc_4">Author’s Note</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0005#a__Hlk132716591">One</a></p>
<p class="P_TOC_Entry_1"><span href="#/section0006#auto_bookmark_toc_7" title="Link target outside of Sample">Two</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0007#auto_bookmark_toc_9" title="Link target outside of Sample">Three</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0008#auto_bookmark_toc_11" title="Link target outside of Sample">Four</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0009#auto_bookmark_toc_13" title="Link target outside of Sample">Five</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0010#auto_bookmark_toc_15" title="Link target outside of Sample">Six</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0011#auto_bookmark_toc_17" title="Link target outside of Sample">Seven</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0012#auto_bookmark_toc_19" title="Link target outside of Sample">Eight</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0013#auto_bookmark_toc_21" title="Link target outside of Sample">Nine</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0014#auto_bookmark_toc_23" title="Link target outside of Sample">Ten</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0015#auto_bookmark_toc_24" title="Link target outside of Sample">About the Author</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0016#auto_bookmark_toc_25" title="Link target outside of Sample">By Rhys Ford</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0017#auto_bookmark_toc_28" title="Link target outside of Sample">Keep Reading - Monster Hall Pass</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0018#a__Hlk132716282" title="Link target outside of Sample">Keep Reading - Elf Shot</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0019#a__Hlk132724018" title="Link target outside of Sample">More from Rhys Ford</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0020#a__Hlk132725167" title="Link target outside of Sample">Visit Dreamspinner Press</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0021#auto_bookmark_toc_35" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0001.vue?21e3cb4f